/**
 * HUB-D — Accès page historique caisse legacy depuis Centre Activité.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Receipt, ArrowRight } from 'lucide-react';
import { caisseHistoriqueLinkFromFilters } from '../../utils/caisse/caisseDisplay';

export default function ActiviteCaisseAccessBanner({ filters }) {
  const to = caisseHistoriqueLinkFromFilters(filters);

  return (
    <div
      className="rounded-xl border p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid="activite-caisse-access-banner"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <Receipt className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-[var(--rm-white)]">Historique caisse complet</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            Référence /caisse-historique conservée — consultation et exports inchangés.
          </p>
        </div>
      </div>
      <Link
        to={to}
        className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center justify-center gap-2 shrink-0 w-full sm:w-auto"
        data-testid="activite-caisse-access-banner-link"
      >
        Ouvrir /caisse-historique
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
